import { render, staticRenderFns } from "./ConNewImageManagement.vue?vue&type=template&id=295112a8&"
import script from "./ConNewImageManagement.vue?vue&type=script&lang=js&"
export * from "./ConNewImageManagement.vue?vue&type=script&lang=js&"
import style0 from "./ConNewImageManagement.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports